/**
 * Robust copy helper: Clipboard API + textarea fallback.
 * Returns true only when text was copied successfully.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
	const value = (text ?? "").trim();
	if (!value) return false;

	if (
		typeof navigator !== "undefined" &&
		navigator.clipboard &&
		typeof navigator.clipboard.writeText === "function"
	) {
		try {
			await navigator.clipboard.writeText(value);
			return true;
		} catch {
			/* fall through */
		}
	}

	try {
		const ta = document.createElement("textarea");
		ta.value = value;
		ta.setAttribute("readonly", "");
		ta.style.position = "fixed";
		ta.style.left = "-9999px";
		ta.style.top = "0";
		document.body.appendChild(ta);
		ta.focus();
		ta.select();
		ta.setSelectionRange(0, value.length);
		const ok = document.execCommand("copy");
		document.body.removeChild(ta);
		return ok;
	} catch {
		return false;
	}
}
